import { RoleType } from '@space-shell/core/store'

export type RoleItem = {
  title: string
  description: string
}

export type Roles = {
  [key in RoleType]: RoleItem
}

export const ROLES: Roles = {
  Creator: {
    title: 'view_as.profile.items.creator.title',
    description: 'view_as.profile.items.creator.description'
  },
  Member: {
    title: 'view_as.profile.items.member_with_access.title',
    description: 'view_as.profile.items.member_with_access.description'
  },
  UserNoAccess: {
    title: 'view_as.profile.items.user_without_access.title',
    description: 'view_as.profile.items.user_without_access.description'
  },
  UserLogout: {
    title: 'view_as.profile.items.logged_out_user.title',
    description: 'view_as.profile.items.logged_out_user.description'
  }
}

export const ROLE_TYPES = Object.keys(ROLES) as RoleType[]

export const ROLES_NOT_ALLOWED_IN_PRODUCT: RoleType[] = [RoleType.UserLogout]
